var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconnavigationanalytics = function SvgIconnavigationanalytics(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Navigation/icon.navigation.analytics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Navigation/icon.navigation.analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 5.500000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.911022,14 C20.6080989,12.7030656 21,11.2415309 21,9.69547622 C21,8.43888811 20.7411115,7.23813361 20.2698986,6.13620891 M13.7165321,0.463382936 C12.7028532,0.162492942 11.6219773,0 10.5,0 C4.70101013,0 0,4.34081256 0,9.69547622 C0,11.1579515 0.350674239,12.544798 0.978615807,13.7882335",
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8718543,5.74178367 C18.9620211,5.82218509 19.0028036,5.89075143 18.9942018,5.94748269 C18.9856,6.00421396 18.9258795,6.06054924 18.8150402,6.11648854 L9.45261397,8.07681558 L18.8718543,5.74178367 Z",
    id: "Rectangle",
    transform: "translate(14.223970, 6.909300) scale(-1, -1) rotate(-35.000000) translate(-14.223970, -6.909300) "
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconnavigationanalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.navigation.analytics.5a57b28f951edfa52f025f9fa4f1559f.svg";